const CLASSES = {
  BTC: { App: () => import('./btc'), Transport: () => import('@ledgerhq/hw-transport-webusb') },
  ETH: { App: () => import('./eth'), Transport: () => import('@ledgerhq/hw-transport-webusb') },
  ONT: { App: () => import('./ont'), Transport: () => import('@ledgerhq/hw-transport-webusb') },
};

export default class LedgerSdk {
  static async create(chain) {
    const sdk = new LedgerSdk();
    await sdk.init(chain);
    return sdk;
  }

  async init(chain) {
    const cls = CLASSES[chain];
    if (!cls) {
      throw new Error('Unsupported chain type.');
    }
    const [{ default: App }, { default: Transport }] = await Promise.all([
      cls.App(),
      cls.Transport(),
    ]);
    this.transport = await Transport.create();
    this.transport.setExchangeTimeout(60000);
    this.app = new App(this.transport);
  }

  async close() {
    if (this.transport) {
      await this.transport.close();
    }
  }

  getAddressAndPublicKey(path) {
    return this.app.getAddressAndPublicKey(path);
  }

  async signTransaction(params) {
    return this.app.signTransaction(params);
  }

  async signMessage(params) {
    return this.app.signMessage(params);
  }
}
